export class WebhookV1SnapshotAccessDeniedArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "jobId",
            "baseName": "jobId",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceName",
            "baseName": "resourceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceProviderId",
            "baseName": "resourceProviderId",
            "type": "string",
            "format": ""
        },
        {
            "name": "accessDeniedItems",
            "baseName": "accessDeniedItems",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "accessDeniedBytes",
            "baseName": "accessDeniedBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1SnapshotAccessDeniedArguments.attributeTypeMap;
    }
    constructor() {
    }
}
